export default "__VITE_ASSET__DJHIg9Lq__"